exports.WebLink = "https://ecweb-backend.entiraclinic.com";
// exports.WebLink = "http://localhost:5005";
